"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isKeyboardOpenSelector = void 0;
var _reselect = require("reselect");
// ====================================================================
// Select data from * state *
// ====================================================================

var _getKeyboardState = function _getKeyboardState(_ref) {
  var keyboardState = _ref.keyboardState;
  return keyboardState;
};

// ====================================================================
// Selectors
// ====================================================================

var isKeyboardOpenSelector = exports.isKeyboardOpenSelector = (0, _reselect.createSelector)(_getKeyboardState, function (keyboardState) {
  return keyboardState.isOppened;
});